export const SET_USER = 'SET_USER'
export const SET_BUCKETS = 'SET_BUCKETS'
export const SET_USERS = 'SET_USERS'
export const SET_NODES = 'SET_NODES'
export const SET_PLANS = 'SET_PLANS'
export const SET_BUCKET_COUNT = 'SET_BUCKET_COUNT'
export const SET_ENTERPRISE_BUCKET_COUNT = 'SET_ENTERPRISE_BUCKET_COUNT'
export const SET_SNACKBAR = 'SET_SNACKBAR'
export const SET_NAVIGATION_DRAWER = 'SET_NAVIGATION_DRAWER'
export const SET_POS = 'SET_POS'
export const SET_BEST_DOWNLOADERS = 'SET_BEST_DOWNLOADERS'
export const SET_DOCUSIGN_PARAMS = 'SET_DOCUSIGN_PARAMS'

export const mutations = {
  [SET_USER] (state, { user }) {
    state.user = user
    if (
      user.username === 'alexandre' ||
      user.username === 'Valentin' ||
      window.location.hostname === 'cl1.km.io'
    ) {
      state.isSuperAdmin = true
    }
  },
  [SET_BUCKETS] (state, { buckets }) {
    state.buckets = buckets
  },
  [SET_USERS] (state, { users }) {
    state.users = users
  },
  [SET_NODES] (state, { nodes }) {
    state.nodes = nodes
  },
  [SET_PLANS] (state, { plans }) {
    state.plans = plans
  },
  [SET_BUCKET_COUNT] (state, { bucketCount }) {
    state.bucketCount = bucketCount
  },
  [SET_ENTERPRISE_BUCKET_COUNT] (state, { enterpriseBucketCount }) {
    state.enterpriseBucketCount = enterpriseBucketCount
  },
  [SET_SNACKBAR] (state, { type, text, isOpen }) {
    state.snackbar = {
      type: type || state.snackbar.type,
      text: text || state.snackbar.text,
      isOpen: isOpen || state.snackbar.isOpen
    }
  },
  [SET_NAVIGATION_DRAWER] (state, isOpened) {
    state.isNavigationDrawerOpened = isOpened
  },
  [SET_POS] (state, pos) {
    state.purchaseOrders = pos
  },
  [SET_BEST_DOWNLOADERS] (state, downloaders) {
    state.bestDownloaders = downloaders
  },
  [SET_DOCUSIGN_PARAMS] (state, params) {
    state.docusignParams = params
  }
}
